import Vue from 'vue'
import App from './App.vue'
import vueCustomElement from 'vue-custom-element'
import VueLazyload from 'vue-lazyload'
import cnWidgetHelperPlugin from './helpers/helpers'

Vue.use(cnWidgetHelperPlugin)
Vue.use(VueLazyload, { attempt: 1 })
Vue.config.productionTip = false
Vue.use(vueCustomElement)
Vue.customElement('cn-widget', App)
